import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  FormControl,
  FormLabel,
  Checkbox,
  Table,
  Tbody,
  Tr,
  Td,
  Thead,
  Th,
  TableContainer,
  Tooltip,
  VisuallyHidden,
  Radio,
  RadioGroup,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Stack,
  IconButton,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { FiUpload } from "react-icons/fi";
import { FileIcon, RemoveIcon } from "../../assets/svgs/Icons";
import { checkFileTypesAndSize, statesList } from "../../Common/utils";
import { toast } from "react-toastify";
import {
  addProcurementForm,
  addSupplier,
  getClassification,
  getCompanyData,
  getAllExternalSuppliers,
  getOneSupplier,
  getAllHeaps,
} from "../../api";
import { useSelector, useDispatch } from "react-redux";
import { getCompanyDetails } from "../../redux/company/CompanySlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { getAllPrograms } from "../../redux/program/ProgramSlice";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { INVENTORY_TYPE } from "../../Common/Constants";

function AddSupplier() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [farmers, setFarmers] = useState([]);
  console.log(farmers, "@farmers")
  const [products, setProducts] = useState([]);
  const [files, setFiles] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const { userData } = useSelector((state) => state.auth);
  const [companyUnits, setCompanyUnits] = useState([]);
  const [companyProducts, setCompanyProducts] = useState([]);
  const [classification, setClassification] = useState([]);
  const [allClassifications, setAllClassifications] = useState([]);
  const { companyDetails } = useSelector((state) => state.company);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("cu_user");
  const [allExternalSuppliers, setAllExternalSuppliers] = useState([]);
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [allHeaps, setAllHeaps] = useState([]);
  const [supplierDetails, setSupplierDetails] = useState({
    name: "",
    type: "",
    contact: {
      email: "",
      number: "",
    },
    address: {
      raw_address: "",
      city: "",
      state: "",
      pinCode: "",
    },
  });

  const handleGoBack = () => {
    navigate("/supplier");
  };

  const handleSelectSupplier = async (selectedSupplier) => {
    const response = await getOneSupplier(selectedSupplier);
    const { name, type, contact, address, supplier_farmers } = response?.data;
    setSupplierDetails({
      name,
      type,
      contact: {
        email: contact?.email,
        number: contact?.number,
      },
      address: {
        raw_address: address?.raw_address,
        city: address?.city,
        state: address?.state,
        pinCode: address?.pinCode,
      },
    });

    //remove mongoId from the farmers 
    const NewfarmerArray = supplier_farmers?.map(({ _id, ...rest }) => rest);
    
    setFarmers(NewfarmerArray);

  };

  const handleFetchHeaps = async () => {
    const response = await getAllHeaps();
    setAllHeaps(response?.data);
  };

  const getUnit = async () => {
    try {
      const result = await getCompanyData(userData?.companyId);

      setCompanyUnits(result?.data?.company_units);
      const filteredProduct = result?.data?.company_products.filter(
        (product) =>
          product.product_productClassification.name ===
          "Seed Cotton (raw cotton)"
      );
      setCompanyProducts(filteredProduct);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getCompany = () => {
    try {
      const result = dispatch(getCompanyDetails(userData?.companyId));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getProductClassification = async () => {
    try {
      const result = await getClassification();
      setAllClassifications(result?.data);
      const filteredProduct = result?.data?.filter(
        (product) => product.name === "Seed cotton (raw cotton)"
      );
      setClassification(filteredProduct);
    } catch (error) {
      console.error(error.message);
    }
  };

  const addFarmer = (farmer) => {
      const updatedFarmers = farmers ? [...farmers, farmer] : [farmer];
      setFarmers(updatedFarmers);

  };

  const addProduct = (product) => {
    setProducts([...products, product]);
  };

  const removeFarmer = (index) => {
      setFarmers(farmers.filter((_, i) => i !== index));
    
  };

  const removeProduct = (index) => {
    setProducts(products.filter((_, i) => i !== index));
  };

  const handleProcurementFileChange = (event) => {
    const file = event.target.files[0];

    const validation = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );

    if (!validation.isValid) {
      setErrorMessage(validation.error);
      toast.error(validation.error);
      return;
    }

    setFiles(file);
    setErrorMessage("");

    toast.success("File Uploaded Successfully");
  };

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  const handleCheckboxChange = (setFieldValue, value) => {
    setFieldValue("type", value);
  };

  const getProgramName = (programId) => {
    return companyDetails?.data?.company_programs?.filter(
      (program) => program?._id === programId
    )?.[0]?.name;
  };

  const getUnitName = (unitId) => {
    return companyUnits?.filter((unit) => unit?._id === unitId)?.[0]?.name;
  };

  const getProductClassificationName = (productClassificationId) => {
    return allClassifications?.filter(
      (productClassification) =>
        productClassification?._id === productClassificationId
    )?.[0]?.name;
  };

  const getAllSuppliers = async () => {
    const response = await getAllExternalSuppliers();
    setAllExternalSuppliers(response?.data);
  };

  useEffect(() => {
    if (userData?.companyId) {
      getUnit();
      getCompany();
      getProductClassification();
      getAllSuppliers();
      handleFetchHeaps();
      handleSelectSupplier(selectedSupplier);
    }
  }, [userData?.companyId, isOptionSelected]);

  useEffect(() => {
    // This effect will update Formik's values whenever supplierDetails changes
    formikRef.current?.setValues({
      ...formikRef.current?.values,
      name: supplierDetails.name || "",
      type: supplierDetails.type || "",
      email: supplierDetails.contact.email || "",
      contact: supplierDetails.contact.number || "",
      address: supplierDetails.address.raw_address || "",
      city: supplierDetails.address.city || "",
      state: supplierDetails.address.state || "",
      pinCode: supplierDetails.address.pinCode || "",
    });
  }, [supplierDetails]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Please enter the organization name"),
    type: Yup.string().required("Please enter the supplier type"),
    // email: Yup.string()
    //   .email("Invalid email")
    //   .required("Please enter the organization email"),
    // contact: Yup.string().required("Please enter the organization contact"),
    address: Yup.string().required("Please enter the organization address"),
    city: Yup.string().required("Please enter the organization city"),
    state: Yup.string().required("Please enter the organization state"),
    pinCode: Yup.string().required("Please enter the organization pin code"),
  });

  const formikRef = React.createRef();

  return (
    <Box marginBottom={"3rem"}>
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>
      <Grid templateColumns="repeat(3, 1fr)" marginTop={"3rem"}>
        <GridItem>
          <Text
            color={"#141D43"}
            fontSize="2xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Add Broker / APMC Details
          </Text>
          <Text color={" #3958DC"} fontSize="sm">
            Please fill necessary details
          </Text>
        </GridItem>
        <GridItem></GridItem>
      </Grid>
      <Box
        marginTop={"2em"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
        bg={
          "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        }
        borderTopRightRadius="100px"
        borderBottomRightRadius={"80px 80px"}
      >
        Broker / APMC Details
      </Box>
      <Formik
        innerRef={formikRef}
        initialValues={{
          name: supplierDetails?.name,
          type: supplierDetails?.type,
          email: supplierDetails?.contact?.email,
          contact: supplierDetails?.contact?.number,
          address: supplierDetails?.raw_address,
          city: supplierDetails?.city,
          state: supplierDetails?.state,
          pinCode: supplierDetails?.pinCode,
          farmerName: "",
          farmerLastName: "",
          farmerVillage: "",
          farmerPinCode: "",
          farmerDistrict: "",
          farmerState: "",
          productType: "",
          programId: "",
          productClassification: "",
          unitId: "",
          procurementDocument: "",
          procurementDocumentName: "",
          purchaseSlipNumber: "",
          date: "",
          netWeight: "",
          grossWeight: "",
          heapType: "new",
          heapId: "",
          transportDetails: "",
          isFarmerSectionVisible: false,
          isProductSectionVisible: false,
        }}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          if (products?.length === 0) {
            toast.error("Please add at least one product.");
            return;
          }

          let supplierId;

          // if (!selectedSupplier) {
            const supplierData = {
              name: values.name,
              type: values.type,
              contact: {
                email: values.email,
                number: values.contact,
              },
              address: {
                raw_address: values.address,
                city: values.city,
                state: values.state,
                pinCode: values.pinCode,
              },
              farmers: farmers,
            };

            const response = await addSupplier(supplierData);
            if (response?.status === 200) {
              toast.success("Supplier added successfully");
              supplierId = response?.data?.data?._id;
            } else {
              toast.error("Failed to add supplier");
              return;
            }
          // } else {
          //   supplierId = selectedSupplier;
          // }

          const finalPayload = {
            supplier: {
              id: supplierId,
              farmer: false,
            },
            procurements: products,
          };

          console.log(finalPayload, "finalPayload")

          const finalResponse = await addProcurementForm(finalPayload);
          if (finalResponse?.status === 200) {
            navigate("/supplier");
            resetForm();
          } else {
            toast.error("Failed to add procurement");
          }
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          touched,
          errors,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              mt="2rem"
              bg="white"
              p="3rem"
              borderRadius="15px"
              boxShadow="rgba(0, 0, 0, 0.1) 0px 4px 12px"
            >
              <FormControl mb="1rem" maxWidth="300px">
              <FormLabel color="#141D43" fontSize="md" fontWeight="700">
              Select Previous Broker / APMC&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                <Select
                  marginTop={"10px"}
                  bgColor="white"
                  color={"#464C64"}
                  border="2px solid  #8fd0fd !important"
                  fontSize="sm"
                  onChange={(e) => {
                    setIsOptionSelected(!isOptionSelected);
                    setSelectedSupplier(e.target.value);
                  }}
                >
                  <option hidden="true">Select Broker/APMC</option>
                  {allExternalSuppliers?.map((data, index) => (
                    <option value={data?._id} key={index}>
                      {data?.name} - {data?.type}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <Grid templateColumns="repeat(2, 1fr)" gap="1rem" mt="2rem">
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Organization Name&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="name"
                      id="name"
                      placeholder="Organization Name"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      isDisabled={selectedSupplier}
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.name && touched.name && (
                      <Text color={"red"} pt="5px">
                        {errors.name}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Supplier Type&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Flex direction="column">
                      <Checkbox
                        isDisabled={selectedSupplier}
                        isChecked={values.type === "BROKER"}
                        onChange={() =>
                          handleCheckboxChange(setFieldValue, "BROKER")
                        }
                      >
                        BROKER
                      </Checkbox>
                      <Checkbox
                        isDisabled={selectedSupplier}
                        isChecked={values.type === "APMC"}
                        onChange={() =>
                          handleCheckboxChange(setFieldValue, "APMC")
                        }
                      >
                        APMC
                      </Checkbox>
                    </Flex>
                    {errors.type && touched.type && (
                      <Text color={"red"} pt="5px">
                        {errors.type}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>

                <GridItem colSpan={1} mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Email&nbsp;
                      {/* <Text as="span" color="red">
                        *
                      </Text> */}
                    </FormLabel>
                    <Input
                      name="email"
                      id="email"
                      isDisabled={selectedSupplier}
                      placeholder="Email"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {/* {errors.email && touched.email && (
                      <Text color={"red"} pt="5px">
                        {errors.email}
                      </Text>
                    )} */}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1} mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Contact Number&nbsp;
                      {/* <Text as="span" color="red">
                        *
                      </Text> */}
                    </FormLabel>
                    <Input
                      type="number"
                      name="contact"
                      placeholder="Contact Number"
                      isDisabled={selectedSupplier}
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.contact}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {/* {errors.contact && touched.contact && (
                      <Text color={"red"} pt="5px">
                        {errors.contact}
                      </Text>
                    )} */}
                  </FormControl>
                </GridItem>

                <GridItem colSpan={1} mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Address (Location)&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      isDisabled={selectedSupplier}
                      name="address"
                      placeholder="Address (Location)"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.address}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.address && touched.address && (
                      <Text color={"red"} pt="5px">
                        {errors.address}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1} mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      City&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="city"
                      placeholder="City"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={handleChange}
                      isDisabled={selectedSupplier}
                      onBlur={handleBlur}
                      value={values.city}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.city && touched.city && (
                      <Text color={"red"} pt="5px">
                        {errors.city}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      State&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Select
                      name="state"
                      placeholder="State"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="17px"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.state}
                      isDisabled={selectedSupplier}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    >
                      <option hidden="true">Select State</option>
                      {statesList.map((state, index) => (
                        <option key={index}>{state}</option>
                      ))}
                    </Select>
                    {errors.state && touched.state && (
                      <Text color={"red"} pt="5px">
                        {errors.state}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Pincode&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      type="number"
                      name="pinCode"
                      placeholder="Pincode"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      isDisabled={selectedSupplier}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.pinCode}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                    {errors.pinCode && touched.pinCode && (
                      <Text color={"red"} pt="5px">
                        {errors.pinCode}
                      </Text>
                    )}
                  </FormControl>
                </GridItem>
              </Grid>
            </Box>
        

          
            <Box
              mt="2rem"
              bg="white"
              p="3rem"
              borderRadius="15px"
              boxShadow="rgba(0, 0, 0, 0.1) 0px 4px 12px"
            >

<Accordion defaultIndex={[0]}>
                  <AccordionItem border="none">
                    <AccordionButton>
                      <Box flex="1" textAlign="left">
                        <Text fontSize="lg" fontWeight="bold">
                          Product Details
                        </Text>
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
              <Grid templateColumns="repeat(2, 1fr)">
                <GridItem colSpan={1}>
                  <Text
                    color={"#141D43"}
                    fontSize="md"
                    fontWeight={"700"}
                    fontFamily={"font.roboto"}
                  >
                    Product Type&nbsp;
                    <Text as="span" color="red">
                      *
                    </Text>
                  </Text>
                  <Select
                    id="productType"
                    name="productType"
                    marginTop="10px"
                    bgColor="white"
                    color="#464C64"
                    border="2px solid #8fd0fd !important"
                    fontSize="sm"
                    value={values.productType}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue("isProductSectionVisible", true);
                    }}
                  >
                    <option hidden="true">Select Type</option>
                    {Object.keys(INVENTORY_TYPE).map((key) => (
                      <option key={key} value={INVENTORY_TYPE[key]}>
                        {INVENTORY_TYPE[key]}
                      </option>
                    ))}
                  </Select>
                </GridItem>
              </Grid>
              <Grid templateColumns="repeat(2, 1fr)" gap="1rem" mt="1rem">
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Product&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Flex marginTop="10px" gap="1rem">
                      <Select
                        name="productClassification"
                        border="2px solid  #8fd0fd !important"
                        bg="#fff"
                        color="#141D43"
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue("isProductSectionVisible", true);
                        }}
                        onBlur={handleBlur}
                        value={values.productClassification}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      >
                        <option hidden="true">Select Product</option>
                        <option default="true" value={classification?.[0]?._id}>
                          {classification?.[0]?.name}
                        </option>
                      </Select>
                    </Flex>
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1} w="175px">
                  <Text
                    color={"#141D43"}
                    fontSize="md"
                    fontWeight={"700"}
                    fontFamily={"font.roboto"}
                  >
                    Document&nbsp;
                    <Text as="span" color="red">
                      *
                    </Text>
                  </Text>
                  <Box mt="1rem">
                    {files ? (
                      <Box
                        display={"flex"}
                        className="overflow-style"
                        boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px"
                      >
                        <>
                          <Box bg="#FFFFFF" w={"250px"} borderRadius={"15px"}>
                            <Box display={"flex"} justifyContent={"right"}>
                              <Button
                                borderColor="#FFFFFF"
                                bg="#ffffff"
                                size="sm"
                                variant="outline"
                                onClick={() => setFiles(null)}
                                leftIcon={<RemoveIcon />}
                              ></Button>
                            </Box>
                            <Box display={"flex"} justifyContent={"center"}>
                              <FileIcon />
                            </Box>
                            <Tooltip label={files?.name}>
                              <Text
                                margin={"auto"}
                                width={"130px"}
                                whiteSpace={"nowrap"}
                                overflow={"hidden"}
                                textOverflow={"ellipsis"}
                              >
                                {files?.name}
                              </Text>
                            </Tooltip>
                          </Box>
                        </>
                      </Box>
                    ) : (
                      <Tooltip label="Please exercise caution when uploading a document, as once it has been uploaded, it cannot be removed or changed.">
                        <Button
                          color="blue.400"
                          bg={"#FFFFFF"}
                          leftIcon={<FiUpload />}
                          borderRadius={"15px"}
                          as="label"
                          htmlFor="file-upload"
                          variant="outline"
                        >
                          Upload
                          <VisuallyHidden>
                            <input
                              id="file-upload"
                              type="file"
                              onChange={handleProcurementFileChange}
                            />
                          </VisuallyHidden>
                        </Button>
                      </Tooltip>
                    )}
                  </Box>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Program&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Select
                      name="programId"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("isProductSectionVisible", true);
                      }}
                      onBlur={handleBlur}
                      value={values.programId}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    >
                      <option hidden="true">Select a Program</option>
                      {companyDetails?.data?.company_programs?.map(
                        (program) => (
                          <option key={program?._id} value={program?._id}>
                            {program.name}
                          </option>
                        )
                      )}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Unit&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Select
                      name="unitId"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("isProductSectionVisible", true);
                      }}
                      onBlur={handleBlur}
                      value={values.unitId}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    >
                      <option hidden="true">Select Unit</option>
                      {companyUnits?.map((data, index) => (
                        <option default="true" value={data?._id} key={index}>
                          {data?.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Invoice Number&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="purchaseSlipNumber"
                      placeholder="Invoice Number"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("isProductSectionVisible", true);
                      }}
                      onBlur={handleBlur}
                      value={values.purchaseSlipNumber}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Invoice Date&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="date"
                      type="date"
                      placeholder="Invoice Date"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      color="#141D43"
                      marginTop="10px"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("isProductSectionVisible", true);
                      }}
                      onBlur={handleBlur}
                      value={values.date}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
              </Grid>
              <Text fontSize="lg" fontWeight="bold" mt="2rem" mb="1rem">
                Quantity&nbsp;
                <Text as="span" color="red">
                  *
                </Text>
              </Text>
              <Grid templateColumns="repeat(2, 1fr)" gap="1rem">
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Net Weight&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="netWeight"
                      type="number"
                      placeholder="Net Weight"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      mt="10px"
                      color="#141D43"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("isProductSectionVisible", true);
                      }}
                      onBlur={handleBlur}
                      value={values.netWeight}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem>
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Gross Weight&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="grossWeight"
                      placeholder="Gross Weight"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      mt="10px"
                      type="number"
                      color="#141D43"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("isProductSectionVisible", true);
                      }}
                      onBlur={handleBlur}
                      value={values.grossWeight}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Heap No.&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <RadioGroup
                      onChange={(value) => setFieldValue("heapType", value)}
                      value={values.heapType}
                    >
                      <Stack direction="row">
                        <Radio value="new">New Heap</Radio>
                        <Radio value="previous">Select Previous Heap</Radio>
                      </Stack>
                    </RadioGroup>

                    {values.heapType === "new" ? (
                      <Input
                        name="heapId"
                        placeholder="Heap No."
                        border="2px solid  #8fd0fd !important"
                        bg="#fff"
                        mt="10px"
                        color="#141D43"
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue("isProductSectionVisible", true);
                        }}
                        onBlur={handleBlur}
                        value={values.heapId}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    ) : values.heapType === "previous" ? (
                      <Select
                        name="heapId"
                        placeholder="Select previous heap"
                        border="2px solid  #8fd0fd !important"
                        bg="#fff"
                        mt="10px"
                        color="#141D43"
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue("isProductSectionVisible", true);
                        }}
                        onBlur={handleBlur}
                        value={values.heapId}
                      >
                        {allHeaps?.map((data, index) => (
                          <option value={data?.number} key={index}>
                            {data?.number}
                          </option>
                        ))}
                      </Select>
                    ) : null}
                  </FormControl>
                </GridItem>
                <GridItem mt="1rem">
                  <FormControl>
                    <FormLabel color="#141D43" fontSize="md" fontWeight="700">
                      Transport Document&nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      name="transportDetails"
                      placeholder="Transport Document"
                      border="2px solid  #8fd0fd !important"
                      bg="#fff"
                      mt="2rem"
                      color="#141D43"
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue("isProductSectionVisible", true);
                      }}
                      onBlur={handleBlur}
                      value={values.transportDetails}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                    />
                  </FormControl>
                </GridItem>
                <Button
                  mt="1rem"
                  bg="#52BBFF"
                  w="171px"
                  color="white"
                  type="button"
                  isLoading={isLoading}
                  onClick={async () => {
                    if (files !== null) {
                      if (
                        values.productType &&
                        values.productClassification &&
                        values.programId &&
                        values.unitId &&
                        values.purchaseSlipNumber &&
                        values.date &&
                        values.netWeight &&
                        values.grossWeight &&
                        values.heapId &&
                        values.transportDetails
                      ) {
                        setIsLoading(true);
                        let procurementFilesRequest;
                        const procurementFilesData = new FormData();

                        procurementFilesData.append("document", files);
                        procurementFilesData.append("doc_type", "OTHER");
                        procurementFilesData.append("userType", "CLIENT");
                        procurementFilesData.append("documentInfo", "OTHER");

                        procurementFilesRequest = await axios({
                          method: "POST",
                          url: `${process.env.REACT_APP_API_HOST}/api/document`,
                          data: procurementFilesData,
                          headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",
                          },
                        });
                        setIsLoading(false);
                        if (procurementFilesRequest?.data?.data) {
                          setIsLoading(true);
                          addProduct({
                            type: values.productType,
                            productClassification: values.productClassification,
                            unitId: values.unitId,
                            programId: values.programId,
                            procurementDocument:
                              procurementFilesRequest?.data?.data?._id,
                            procurementDocumentName:
                              procurementFilesRequest?.data?.data?.name,
                            purchaseSlipNumber: values.purchaseSlipNumber,
                            date: values.date,
                            stockQuantity: {
                              netWeight: values.netWeight,
                              grossWeight: values.grossWeight,
                            },
                            heapId: values.heapId,
                            transportDetails: values.transportDetails,
                          });
                          setIsLoading(false);
                          resetForm({
                            values: {
                              ...values,
                              productType: "",
                              productClassification: "",
                              programId: "",
                              unitId: "",
                              procurementDocument: "",
                              procurementDocumentName: "",
                              purchaseSlipNumber: "",
                              date: "",
                              netWeight: "",
                              grossWeight: "",
                              heapId: "",
                              transportDetails: "",
                            },
                          });
                          setFiles(null);
                        }
                      } else {
                        toast.error("Please fill all product fields");
                      }
                    } else {
                      toast.error("Please upload the document");
                    }
                  }}
                >
                  Add Product
                </Button>
              </Grid>
              </AccordionItem>
              </Accordion>
            </Box>

            <Box
                mt="2rem"
                 bg="#fff"
                p="1rem"
                borderRadius="15px"
                boxShadow="rgba(0, 0, 0, 0.1) 0px 4px 12px"
              >
                <Accordion defaultIndex={[0]}>
                  <AccordionItem border="none">
                    <AccordionButton>
                      <Box flex="1" textAlign="left">
                        <Text fontSize="lg" fontWeight="bold">
                          Farmer Details (Optional)
                        </Text>
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>

                    <AccordionPanel pb="4">
                      <Grid templateColumns="repeat(2, 1fr)" gap="1rem">
                        <GridItem colSpan={1}>
                          <FormControl>
                            <FormLabel
                              color="#141D43"
                              fontSize="md"
                              fontWeight="700"
                            >
                              Farmer Name
                            </FormLabel>
                            <Input
                              name="farmerName"
                              placeholder="Farmer Name"
                              border="2px solid  #8fd0fd !important"
                              bg="#fff"
                              color="#141D43"
                              marginTop="10px"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("isFarmerSectionVisible", true);
                              }}
                              onBlur={handleBlur}
                              value={values.farmerName}
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={1}>
                          <FormControl>
                            <FormLabel
                              color="#141D43"
                              fontSize="md"
                              fontWeight="700"
                            >
                              Last Name
                            </FormLabel>
                            <Input
                              name="farmerLastName"
                              placeholder="Last Name"
                              border="2px solid  #8fd0fd !important"
                              bg="#fff"
                              color="#141D43"
                              marginTop="10px"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("isFarmerSectionVisible", true);
                              }}
                              onBlur={handleBlur}
                              value={values.farmerLastName}
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <Text fontSize="lg" fontWeight="bold" mt="1rem">
                            Location of Farmer
                          </Text>
                        </GridItem>
                        <GridItem colSpan={1}>
                          <FormControl>
                            <FormLabel
                              color="#141D43"
                              fontSize="md"
                              fontWeight="700"
                            >
                              Village
                            </FormLabel>
                            <Input
                              name="farmerVillage"
                              placeholder="Village"
                              border="2px solid  #8fd0fd !important"
                              bg="#fff"
                              color="#141D43"
                              marginTop="10px"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("isFarmerSectionVisible", true);
                              }}
                              onBlur={handleBlur}
                              value={values.farmerVillage}
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={1}>
                          <FormControl>
                            <FormLabel
                              color="#141D43"
                              fontSize="md"
                              fontWeight="700"
                            >
                              District
                            </FormLabel>
                            <Input
                              name="farmerDistrict"
                              marginTop="10px"
                              placeholder="District"
                              border="2px solid  #8fd0fd !important"
                              bg="#fff"
                              color="#141D43"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("isFarmerSectionVisible", true);
                              }}
                              onBlur={handleBlur}
                              value={values.farmerDistrict}
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={1}>
                          <FormControl>
                            <FormLabel
                              color="#141D43"
                              fontSize="md"
                              fontWeight="700"
                            >
                              State
                            </FormLabel>
                            <Select
                              name="farmerState"
                              placeholder="State"
                              border="2px solid  #8fd0fd !important"
                              bg="#fff"
                              color="#141D43"
                              marginTop="10px"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("isFarmerSectionVisible", true);
                              }}
                              onBlur={handleBlur}
                              value={values.farmerState}
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            >
                              <option hidden="true">Select State</option>
                              {statesList.map((state, index) => (
                                <option key={index}>{state}</option>
                              ))}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={1}>
                          <FormControl>
                            <FormLabel
                              color="#141D43"
                              fontSize="md"
                              fontWeight="700"
                            >
                              Pin Code
                            </FormLabel>
                            <Input
                              name="farmerPinCode"
                              placeholder="Pin Code"
                              border="2px solid  #8fd0fd !important"
                              bg="#fff"
                              color="#141D43"
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("isFarmerSectionVisible", true);
                              }}
                              onBlur={handleBlur}
                              value={values.farmerPinCode}
                              _placeholder={{
                                opacity: 1,
                                color: " #464C64",
                                fontSize: "14px",
                              }}
                            />
                          </FormControl>
                        </GridItem>
                      </Grid>
                      <Button
                        mt="1rem"
                        bg="#52BBFF"
                        w="171px"
                        color="white"
                        onClick={() => {
                          if (
                            values.farmerName &&
                            values.farmerLastName &&
                            values.farmerVillage &&
                            values.farmerDistrict &&
                            values.farmerState &&
                            values.farmerPinCode
                          ) {
                            addFarmer({
                              firstName: values.farmerName,
                              lastName: values.farmerLastName,
                              address: {
                                raw_address: values.farmerVillage,
                                district: values.farmerDistrict,
                                state: values.farmerState,
                                pinCode: values.farmerPinCode,
                              },
                            });
                            resetForm({
                              values: {
                                ...values,
                                farmerName: "",
                                farmerLastName: "",
                                farmerVillage: "",
                                farmerPinCode: "",
                                farmerDistrict: "",
                                farmerState: "",
                              },
                            });
                          } else {
                            toast.error("Please fill all farmer fields");
                          }
                        }}
                      >
                        Add Farmer
                      </Button>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              </Box>
            <Box display={"flex"} justifyContent={"center"}>
              {errorMessage && (
                <Box
                  bg="crimson"
                  color="white"
                  p="1rem"
                  borderRadius="15px"
                  mb="1rem"
                  w="60%"
                  textAlign={"center"}
                >
                  {errorMessage}
                  <Button
                    size="sm"
                    variant="outline"
                    ml="1rem"
                    bg="white"
                    color="black"
                    onClick={clearErrorMessage}
                  >
                    <RemoveIcon />
                  </Button>
                </Box>
              )}
            </Box>
            <Button
              bg="#52BBFF"
              color="white"
              mt="2rem"
              w="171px"
              type="submit"
            >
              Register
            </Button>
          </form>
        )}
      </Formik>

      {farmers?.length > 0 && (
        <Box mt="2rem" bg="white" p="3rem" borderRadius="15px">
          <Text fontSize="xl" fontWeight="bold" mb="1rem">
            Farmers
          </Text>
          <TableContainer className="overflow-style">
            <Table
              variant={"simple"}
              size="md"
              bg={"#fff"}
              borderRadius={"15px"}
              pr={"1rem"}
            >
              <Thead>
                <Tr>
                  <Th color="brand.blue" textTransform="capitalize">
                    Sr no.
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Name
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Last Name
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Village
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    District
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    State
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Pin Code
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Action
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {farmers.map((farmer, index) => (
                  <Tr key={index}>
                    <Td>{index + 1}</Td>
                    <Td>{farmer.firstName}</Td>
                    <Td>{farmer.lastName}</Td>
                    <Td>{farmer.address.raw_address}</Td>
                    <Td>{farmer.address.district}</Td>
                    <Td>{farmer.address.state}</Td>
                    <Td>{farmer.address.pinCode}</Td>
                    <Td>
                      <Box cursor="pointer" onClick={() => removeFarmer(index)}>
                        <RemoveIcon />
                      </Box>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      )}


      {products?.length > 0 && (
        <Box mt="2rem" bg="white" p="3rem" borderRadius="15px">
          <Text fontSize="xl" fontWeight="bold" mb="1rem">
            Products
          </Text>
          <TableContainer className="overflow-style">
            <Table
              variant={"simple"}
              size="md"
              bg={"#fff"}
              borderRadius={"15px"}
              pr={"1rem"}
            >
              <Thead>
                <Tr>
                  <Th color="brand.blue" textTransform="capitalize">
                    Sr no.
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Product Type
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Product
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Program
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Unit
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Invoice Number
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Invoice Date
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Net Weight
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Gross Weight
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Heap No.
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Transport Document
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Document
                  </Th>
                  <Th color="brand.blue" textTransform="capitalize">
                    Action
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {products.map((product, index) => (
                  <Tr key={index}>
                    <Td>{index + 1}</Td>
                    <Td>{product.type}</Td>
                    <Td>
                      {getProductClassificationName(
                        product.productClassification
                      )}
                    </Td>
                    <Td>{getProgramName(product.programId)}</Td>
                    <Td>{getUnitName(product.unitId)}</Td>
                    <Td>{product.purchaseSlipNumber}</Td>
                    <Td>{product.date}</Td>
                    <Td>{product.stockQuantity.netWeight}</Td>
                    <Td>{product.stockQuantity.grossWeight}</Td>
                    <Td>{product.heapId}</Td>
                    <Td>{product.transportDetails}</Td>
                    <Td>
                      <Tooltip label={product?.procurementDocumentName}>
                        <Text
                          maxWidth="50px"
                          overflow="hidden"
                          textOverflow="ellipsis"
                        >
                          {product?.procurementDocumentName}
                        </Text>
                      </Tooltip>
                    </Td>
                    <Td>
                      <Box
                        cursor="pointer"
                        onClick={() => removeProduct(index)}
                      >
                        <RemoveIcon />
                      </Box>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  );
}

export default AddSupplier;
